<template>
  <input ref="inputRef" type="text" />
</template>

<script>
import { de } from "date-fns/locale";
import { useCurrencyInput } from "vue-currency-input";

export default {
  name: "CurrencyInput",
  props: {
    value: Number, // Vue 2: value
    options: Object,
  },
  setup(props) {
    const defaultOptions = {
      currency: "USD",
      locale: "de-DE",
      currencyDisplay: "hidden", //"code",
      precision: 2,
      hideCurrencySymbolOnFocus: true,
      hideGroupingSeparatorOnFocus: true,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: false,
      useGrouping: true,
      accountingSign: false,
    };
    const { inputRef } = useCurrencyInput({ ...defaultOptions, ...props.options });

    return { inputRef };
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      // Also emit focus/blur events that md-field listens to
      this.$emit("focus");
    },
  },
};
</script>
